/**
 * PrecursorBarControls Component
 *
 * Slim-bar timeline sparkline + map for the Precursor/Control tab, bound to the
 * selected node's mapped reports (not the IRP-wide data). Thin wrapper over the
 * reusable TimelineMapControls.
 */

import React, {useMemo} from 'react';
import TimelineMapControls from './TimelineMapControls';
import {IrpReportLocationDTO} from '../../../../../../@types/integrated-risk-picture';
import {useNodeTabCache, useSelectedNodeId} from '../../../../../../stores/irp-workbook.store';

const PrecursorBarControls: React.FC = () => {
    const nodeTabCache = useNodeTabCache();
    const selectedNodeId = useSelectedNodeId();

    // The selected node's mapped-report locations. Guard against stale cache while a
    // different node's data is still loading.
    const reports = useMemo((): IrpReportLocationDTO[] => {
        if (!nodeTabCache || nodeTabCache.nodeId !== selectedNodeId) return [];
        return (nodeTabCache.mappedReports ?? []).map((r) => ({
            reportId: r.reportId,
            latitude: r.latitude,
            longitude: r.longitude,
            dateTime: r.dateTime,
        }));
    }, [nodeTabCache, selectedNodeId]);

    return <TimelineMapControls reports={reports} />;
};

export default PrecursorBarControls;
